import React from "react";

import type { Challenge } from "../api/languageChallenge";
import duoLanding from "../images/duo-landing.svg";
import styles from "../styles/Landing.module.scss";

export interface Props {
  challenge?: Challenge;
}

const Landing = ({ challenge }: Props) => {
  const endTime =
    challenge && new Date(challenge.endTimeSecondsSinceEpoch * 1000);

  return (
    <div className={styles.wrap}>
      <img alt="duo landing" className={styles.duo} src={duoLanding} />
      <div className={styles["text-container"]}>
        {challenge && <h1 className={styles.title}>{challenge.description}</h1>}
        {endTime && (
          <p className={styles.subtitle}>
            ends on{" "}
            {endTime.toLocaleString("en-US", { timeZone: "America/New_York" })},
            Eastern Time
          </p>
        )}
      </div>
    </div>
  );
};
export default Landing;
